import { ButtonProps } from '../jdsbutton/logic';
import { IPROP_MAP } from '../../generators/modifyProps';
import { JDSContentBlockProps } from './generated';
import { resolvePropObjectKeys } from '../../utils/componenthelpers';

const legacySizes = ['m', 'l', 'xl', 's', 'xs', 'xxs'] as const;

export interface CTA {
  /**
   * @deprecated
   * pass the title as string to `secondaryCTA`
   */
  title: string;
  /**
   * @deprecated
   * Use `onSecondaryClick`
   */
  onClick?: ButtonProps['onClick'];
  /**
   * @deprecated
   * Links do not support button props anymore
   */
  _button?: ButtonProps;
}

export interface ContentBlockType
  extends Omit<
    JDSContentBlockProps,
    | 'size'
    | 'singleButton'
    | 'shouldOverrideColor'
    | 'primaryCTA'
    | 'secondaryCTA'
  > {
  /**
   * Determines the size of the ContentBlock. Size dictates the text and spacing.
   * For size=`xtra-xtra-small`, the layout also changes if only a single CTA is sent.
   */
  size?: (typeof legacySizes)[number] | JDSContentBlockProps['size'];
  /**
   * Please see `Link>LinkType`. The `button={}` parameter can be sent to overwrite
   * default button behaviours. E.g. different kind, destructive, with icons etc.
   *
   */
  primaryCTA?: string | CTA;
  /**
   * Please see `Link>LinkType`. The `button={}` parameter can be sent to overwrite
   * default button behaviours. E.g. different kind, destructive, with icons etc.
   */
  secondaryCTA?: string | CTA;
}

export const PROP_MAP: IPROP_MAP<ContentBlockType> = (props) => {
  if (legacySizes.includes(props.size as (typeof legacySizes)[number])) {
    console.warn(
      legacySizes.join(','),
      'are deprecated. Use sizes staring with xtra, large, small'
    );
  }
  return {
    primaryCTA: {
      properties: {
        primaryCTA: resolvePropObjectKeys(props.primaryCTA, 'title', ''),
        onPrimaryClick:
          props.onPrimaryClick || (props.primaryCTA as CTA)?.onClick
      }
    },
    secondaryCTA: {
      properties: {
        secondaryCTA: resolvePropObjectKeys(props.secondaryCTA, 'title', ''),
        onSecondaryClick:
          props.onSecondaryClick || (props.secondaryCTA as CTA)?.onClick
      }
    },

    size: {
      defaultValue: 'xtra-small',
      variations: {
        s: {
          size: 'small'
        },
        m: {
          size: 'medium'
        },
        xs: {
          size: 'xtra-small'
        },
        xxs: {
          size: 'xtra-xtra-small'
        },
        l: {
          size: 'large'
        },
        xl: {
          size: 'xtra-large'
        }
      }
    }
  };
};
